export default __webpack_public_path__ + "static/media/Handguard of Jagged Barbs.e2b7d0ba.jpg";